// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2fe95d42","513":"ba09c246","787":"fdae33a0","793":"abf61f85"}[chunkId] + ".chunk.js";
};